<template>
  <div>
    <section class="section is-main-section">
      <CardComponent>
        <div class="section has-text-centered">
          <h1 class="title">Manage Organisations</h1>
          <div class="buttons-list has-text-right">
            <b-button
              type="is-primary"
              icon-left="plus"
              tag="router-link"
              :to="{ name: 'CreateOrganisation' }"
              >Add</b-button
            >
          </div>
          <b-field class="has-margin-top-15">
            <b-input
              v-model="search"
              placeholder="Search..."
              type="search"
              icon="magnify"
            >
            </b-input>
          </b-field>
          <b-table
            :data="items"
            :bordered="false"
            :striped="true"
            :narrowed="true"
            :hoverable="true"
            :loading="loading"
            :focusable="false"
            :mobile-cards="true"
            :paginated="true"
          >
            <template slot-scope="props">
              <b-table-column field="name" label="Name">
                {{ props.row.name }}
              </b-table-column>

              <b-table-column label="Actions">
                <b-button
                  class="has-margin-right-10"
                  @click="
                    $router.push({
                      name: 'EditOrganisation',
                      params: { id: props.row.id }
                    })
                  "
                  >Edit</b-button
                >
                <b-button
                  class="has-margin-right-10"
                  @click="
                    $router.push({
                      name: 'ManageUsersByOrganisation',
                      params: { id: props.row.id }
                    })
                  "
                  >Manage Users</b-button
                >
                <b-button
                  class="has-margin-right-10"
                  @click="confirmDelete(props.row)"
                  >Delete</b-button
                >
              </b-table-column>
            </template>

            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <p>
                    <b-icon icon="emoticon-sad" size="is-medium"> </b-icon>
                  </p>
                  <p>No organisations yet.</p>
                </div>
              </section>
            </template>
          </b-table>
        </div>
      </CardComponent>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CardComponent from '@/components/CardComponent'
import OrganisationApi from '@/api/organisations'

export default {
  name: 'ManageOrgnanisations',
  components: {
    CardComponent
  },
  metaInfo: {
    title: 'Manage Organisations'
  },
  computed: {
    ...mapGetters(['user'])
  },
  async created() {
    this.fetchAll()
  },
  data() {
    return {
      loading: true,
      items: [],
      search: ''
    }
  },
  methods: {
    ...mapActions(['getUser']),
    confirmDelete(item) {
      this.$buefy.dialog.confirm({
        message: 'Are you sure you want to delete this organisation?',
        onConfirm: () => {
          OrganisationApi.remove(item)
            .then(() => {
              this.$buefy.toast.open({
                message: 'Organisation deleted successfully!',
                position: 'is-top',
                type: 'is-success'
              })
              this.fetchAll()
              this.loading = false
            })
            .catch(err => {
              this.$buefy.toast.open({
                message: 'Error deleting organisation',
                position: 'is-top',
                type: 'is-danger'
              })
              this.loading = false
            })
        }
      })
    },
    deleteOrgan() {},
    async fetchAll() {
      this.loading = true
      this.items = await OrganisationApi.getAll()
      this.loading = false
    }
  }
}
</script>
